export interface IResultPerCityAPI {
  control_group_total: number;
  control_group_total_pre_campaign: number | null;
  control_group_visited: number;
  control_group_visited_pre_campaign: number | null;
  created_on_utc: string;
  location_id: number;
  exposed_to_ad_group_total: number;
  exposed_to_ad_group_total_pre_campaign: number | null;
  exposed_to_ad_group_visited: number;
  exposed_to_ad_group_visited_pre_campaign: number | null;
  id: number;
  liftanalysis_id: number;
  modified_on_utc: string;
  swarm_aws_region: string;
}

export default class ResultsPerCity {
  controlGroupTotal: number;

  controlGroupTotalPreCampaign: number | null;

  controlGroupVisited: number;

  controlGroupVisitedPreCampaign: number | null;

  createdOnUtc: string;

  locationId: number;

  exposedToAdGroupTotal: number;

  exposedToAdGroupTotalPreCampaign: number | null;

  exposedToAdGroupVisited: number;

  exposedToAdGroupVisitedPreCampaign: number | null;

  id: number;

  liftAnalysisId: number;

  modifiedOnUtc: string;

  swarmAwsRegion: string;

  constructor(
    controlGroupTotal: number,
    controlGroupTotalPreCampaign: number | null,
    controlGroupVisited: number,
    controlGroupVisitedPreCampaign: number | null,
    createdOnUtc: string,
    locationId: number,
    exposedToAdGroupTotal: number,
    exposedToAdGroupTotalPreCampaign: number | null,
    exposedToAdGroupVisited: number,
    exposedToAdGroupVisitedPreCampaign: number | null,
    id: number,
    liftAnalysisId: number,
    modifiedOnUtc: string,
    swarmAwsRegion: string,
  ) {
    this.controlGroupTotal = controlGroupTotal;
    this.controlGroupTotalPreCampaign = controlGroupTotalPreCampaign;
    this.controlGroupVisited = controlGroupVisited;
    this.controlGroupVisitedPreCampaign = controlGroupVisitedPreCampaign;
    this.createdOnUtc = createdOnUtc;
    this.locationId = locationId;
    this.exposedToAdGroupTotal = exposedToAdGroupTotal;
    this.exposedToAdGroupTotalPreCampaign = exposedToAdGroupTotalPreCampaign;
    this.exposedToAdGroupVisited = exposedToAdGroupVisited;
    this.exposedToAdGroupVisitedPreCampaign = exposedToAdGroupVisitedPreCampaign;
    this.id = id;
    this.liftAnalysisId = liftAnalysisId;
    this.modifiedOnUtc = modifiedOnUtc;
    this.swarmAwsRegion = swarmAwsRegion;
  }

  static fromApi(apiObject: IResultPerCityAPI): ResultsPerCity {
    return new ResultsPerCity(
      apiObject.control_group_total,
      apiObject.control_group_total_pre_campaign,
      apiObject.control_group_visited,
      apiObject.control_group_visited_pre_campaign,
      apiObject.created_on_utc,
      apiObject.location_id,
      apiObject.exposed_to_ad_group_total,
      apiObject.exposed_to_ad_group_total_pre_campaign,
      apiObject.exposed_to_ad_group_visited,
      apiObject.exposed_to_ad_group_visited_pre_campaign,
      apiObject.id,
      apiObject.liftanalysis_id,
      apiObject.modified_on_utc,
      apiObject.swarm_aws_region,
    );
  }

  toApi(): IResultPerCityAPI {
    return {
      control_group_total: this.controlGroupTotal,
      control_group_total_pre_campaign: this.controlGroupTotalPreCampaign,
      control_group_visited: this.controlGroupVisited,
      control_group_visited_pre_campaign: this.controlGroupVisitedPreCampaign,
      created_on_utc: this.createdOnUtc,
      location_id: this.locationId,
      exposed_to_ad_group_total: this.exposedToAdGroupTotal,
      exposed_to_ad_group_total_pre_campaign: this.exposedToAdGroupTotalPreCampaign,
      exposed_to_ad_group_visited: this.exposedToAdGroupVisited,
      exposed_to_ad_group_visited_pre_campaign: this.exposedToAdGroupVisitedPreCampaign,
      id: this.id,
      liftanalysis_id: this.liftAnalysisId,
      modified_on_utc: this.modifiedOnUtc,
      swarm_aws_region: this.swarmAwsRegion,
    };
  }
}
